import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const faqs = [
  {
    q: "Mardin'e gitmek için en iyi zaman hangisi?",
    a: "Mardin'i ziyaret etmek için en ideal dönemler Mart–Mayıs ve Eylül–Kasım aylarıdır. İlkbaharda bölge çiçek açar ve hava ılımandır; sonbaharda ise altın renkli manzaralar eşliğinde şehri keşfedebilirsiniz. Yaz aylarında (Haziran–Ağustos) sıcaklık 40°C'yi aşabilir; kış ise soğuk ve yağışlı geçer.",
  },
  {
    q: "Mardin'de mutlaka görülmesi gereken yerler hangileri?",
    a: "Deyrulzafaran Manastırı, Kasımiye Medresesi, Zinciriye Medresesi, Mardin Müzesi, Ulu Cami, Şehidiye Camii ve Minaresi, Mor Gabriel Manastırı (Midyat), Dara Antik Kenti ve Hasankeyf (Batman) Mardin çevresinin mutlaka görülmesi gereken yerleri arasındadır. Tarihi çarşı ve gümüş işçiliği atölyeleri de ayrı bir deneyim sunar.",
  },
  {
    q: "Mardin'de ne yenilmeli?",
    a: "Mardin mutfağı Türk, Kürt, Süryani ve Arap mutfaklarının eşsiz bir sentezidir. Mutlaka tatmanız gerekenler: kibe (içli köfte), mırra kahvesi (acı Arap kahvesi), kuru soğan dolması, kaburga dolması, Mardin usulü mercimek çorbası, tatlı olarak ise kadayıf ve şıllık. Tarihi çarşıdaki küçük lokantalarda bu lezzetleri en otantik haliyle bulabilirsiniz.",
  },
  {
    q: "Mardin'e nasıl gidilir?",
    a: "Mardin Havalimanı, İstanbul ve Ankara'dan direkt uçuşlarla bağlantılıdır; uçuş süresi yaklaşık 1,5–2 saattir. Diyarbakır'dan otobüsle yaklaşık 1,5 saat, Şanlıurfa'dan ise 2,5 saat sürer. Şehir içinde dolmuş ve taksi kullanılabilir; tarihi şehir merkezi yürüyerek de gezilebilir.",
  },
  {
    q: "Mardin'de kaç gün geçirmek gerekir?",
    a: "Mardin şehir merkezini (tarihi çarşı, medreseler, camiler) görmek için 2 gün yeterlidir. Deyrulzafaran Manastırı, Mor Gabriel ve Dara Antik Kenti'ni eklerseniz 3–4 gün idealdir. Hasankeyf, Midyat ve Şanlıurfa'yı da kapsayan bir Güneydoğu turu için 7–10 gün ayırabilirsiniz.",
  },
  {
    q: "Deyrulzafaran Manastırı nedir ve nasıl ziyaret edilir?",
    a: "Deyrulzafaran (Safran Manastırı), MS 4. yüzyılda kurulan ve Süryani Ortodoks Kilisesi'nin önemli bir merkezi olan tarihi bir manastırdır. Mardin şehir merkezine 5 km uzaklıktadır; taksi veya dolmuşla ulaşılabilir. Rehberli turlar düzenlenmekte olup ziyaret saatleri 08:00–12:00 ve 13:00–17:00 arasındadır. Manastır hâlâ aktif olarak kullanılmaktadır.",
  },
  {
    q: "Mardin'de gümüş takı alınabilir mi?",
    a: "Evet, Mardin dünyaca ünlü gümüş işçiliğiyle tanınır. Tarihi çarşıdaki atölyelerde ustalar geleneksel telkari tekniğiyle özgün takılar üretmektedir. Küpe, bilezik, kolye ve broşlar en çok tercih edilen ürünler arasındadır. Satın almadan önce birkaç dükkanı karşılaştırmanızı ve ürünün gerçek gümüş olduğunu teyit etmenizi öneririz.",
  },
  {
    q: "Mardin'den Hasankeyf'e nasıl gidilir?",
    a: "Hasankeyf, Mardin'e yaklaşık 100 km uzaklıkta Batman iline bağlıdır. Özel araçla yaklaşık 1,5 saat sürer. Mardin'den düzenlenen günübirlik turlarla da ulaşılabilir. Hasankeyf, Dicle Nehri kıyısındaki tarihi kaya evleri ve kalesiyle eşsiz bir manzara sunar; ancak Ilısu Barajı nedeniyle bazı bölümler su altında kalmıştır.",
  },
  {
    q: "Mardin'de konaklama seçenekleri nelerdir?",
    a: "Mardin'de tarihi taş konaklarda konaklama deneyimi yaşamak şiddetle tavsiye edilir. Mezopotamya ovasına bakan teraslı butik oteller şehrin en özgün konaklama seçenekleridir. Fiyatlar sezona ve otele göre 1.500–6.000 TL arasında değişmektedir. Erken rezervasyon yapmanızı öneririz; özellikle bahar ve sonbahar dönemlerinde doluluk oranı yüksektir.",
  },
  {
    q: "Mardin'de mırra kahvesi nedir?",
    a: "Mırra, Mardin ve Güneydoğu Anadolu'ya özgü, çok acı ve yoğun bir Arap kahvesidir. Kakule ve safranla tatlandırılarak küçük fincanlarda servis edilir. Geleneksel misafirperver kültürünün simgesi olan mırra, ev ziyaretlerinde ve özel davetlerde ikram edilir. Tarihi çarşıdaki kafelerde deneyebilirsiniz; ilk yudumda acılığına şaşırabilirsiniz ama tadı damağınızda kalır.",
  },
  {
    q: "Mardin çevresinde başka hangi destinasyonlar var?",
    a: "Mardin'in çevresinde keşfedilmeyi bekleyen pek çok destinasyon bulunmaktadır: Midyat (Süryani kültürü ve telkari işçiliği), Mor Gabriel Manastırı (MS 397'den kalma dünyanın en eski manastırlarından biri), Dara Antik Kenti (Roma dönemi su sarnıçları), Savur (şelale ve doğa), Nusaybin (tarihi sınır kenti) ve Şanlıurfa (Göbeklitepe, Balıklıgöl).",
  },
  {
    q: "Mardin'de fotoğraf çekmek için en iyi noktalar nereler?",
    a: "Mardin'in en iyi fotoğraf noktaları: şehrin panoramik manzarasını sunan Mardin Kalesi çevresi, gün batımında altın rengine bürünen tarihi çarşı sokakları, Deyrulzafaran Manastırı'nın taş avlusu, Kasımiye Medresesi'nin geometrik süslemeleri ve Mezopotamya ovasına bakan teraslar. Sabah erken saatler ve gün batımı en dramatik ışığı sunar.",
  },
];

const MardinFaq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const title = "Mardin Seyahat SSS — Taş Evler, Manastırlar ve Güneydoğu Rehberi 2026";
    const desc = "Mardin'e seyahat planlayanlar için en sık sorulan sorular: Deyrulzafaran Manastırı, tarihi çarşı, mırra kahvesi, ulaşım ve konaklama hakkında kapsamlı rehber.";
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setCanonical = (url: string) => {
      let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
      el.setAttribute("href", url);
    };
    const injectSchema = (id: string, data: object) => {
      let el = document.getElementById(id);
      if (!el) { el = document.createElement("script"); el.id = id; el.setAttribute("type", "application/ld+json"); document.head.appendChild(el); }
      el.textContent = JSON.stringify(data);
    };

    setCanonical("https://geziturkiyem.com/mardin-sss");
    setMeta("description", desc);
    setMeta("keywords", "mardin seyahat, mardin gezilecek yerler, deyrulzafaran manastiri, mardin sss, mardin rehberi, guneydogu anadolu, mardin tas evler, mardin kasimiye medresesi, mardin zinciriye medresesi, mardin muzesi, mardin ulu cami, mor gabriel manastiri, midyat, dara antik kenti, hasankeyf, mardin mirra kahvesi, mardin gumüs taki, mardin telkari, mardin kibe, mardin ne zaman gidilir, mardin konaklama, mardin ulasim, mardin gunubirlik gezi, mardin fotograf noktalari, mardin mezopotamya, mardin suryanice, mardin cok kulturlu, mardin panoramik manzara, mardin savur, mardin nusaybin, batman hasankeyf, guneydogu anadolu turu, mardin sanliurfa diyarbakir turu");
    setMeta("og:title", title, true);
    setMeta("og:description", desc, true);
    setMeta("og:type", "article", true);
    setMeta("og:url", "https://geziturkiyem.com/mardin-sss", true);
    setMeta("og:image", "https://readdy.ai/api/search-image?query=Mardin%20Turkey%20ancient%20stone%20city%20hilltop%20Mesopotamia%20plain%20golden%20sunset%20traditional%20architecture%20minaret%20panoramic&width=1200&height=630&seq=mar-sss-og&orientation=landscape", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", desc);

    injectSchema("schema-mardin-faq", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((f) => ({
        "@type": "Question",
        "name": f.q,
        "acceptedAnswer": { "@type": "Answer", "text": f.a },
      })),
    });

    injectSchema("schema-mardin-breadcrumb", {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://geziturkiyem.com/" },
        { "@type": "ListItem", "position": 2, "name": "Mardin SSS", "item": "https://geziturkiyem.com/mardin-sss" },
      ],
    });

    return () => {
      document.title = "Türkiye Seyahat Rehberi";
      ["schema-mardin-faq", "schema-mardin-breadcrumb"].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="relative pt-20 pb-16 overflow-hidden bg-stone-900">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Mardin%20Turkey%20ancient%20stone%20city%20hilltop%20panoramic%20view%20Mesopotamia%20plain%20golden%20sunset%20traditional%20architecture%20wide%20dramatic&width=1400&height=500&seq=mar-sss-hero&orientation=landscape"
            alt="Mardin"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
        </div>
        <div className="relative max-w-3xl mx-auto px-4 md:px-8 text-center">
          <nav className="flex items-center justify-center gap-2 text-xs text-stone-400 mb-5">
            <Link to="/" className="hover:text-white transition-colors">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Mardin SSS</span>
          </nav>
          <span className="inline-block bg-amber-500/20 border border-amber-400/30 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-widest">
            Sık Sorulan Sorular
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Mardin Seyahat Rehberi
          </h1>
          <p className="text-stone-300 text-sm max-w-xl mx-auto">
            Mardin'e seyahat planlayanların en çok merak ettiği sorular ve kapsamlı Güneydoğu rehberi.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-14">
        <div className="bg-amber-50 border border-amber-100 rounded-2xl p-6 mb-10">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
              <i className="ri-ancient-gate-line text-amber-600 text-xl"></i>
            </div>
            <div>
              <h2 className="font-bold text-stone-900 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                Mardin Hakkında
              </h2>
              <p className="text-stone-600 text-sm leading-relaxed">
                Mezopotamya ovasına hâkim bir tepe üzerinde kurulu Mardin; taş mimarisi, Süryani manastırları, çok kültürlü dokusu ve eşsiz panoramik manzarasıyla UNESCO Dünya Mirası listesinde yer almaktadır. Aşağıda Mardin seyahati hakkında en sık sorulan soruları bulabilirsiniz.
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`border rounded-2xl overflow-hidden transition-all duration-200 ${
                openIndex === i ? "border-amber-300 bg-amber-50/50" : "border-stone-100 bg-white hover:border-stone-200"
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
              >
                <h4 className={`font-semibold text-sm leading-snug pr-4 ${openIndex === i ? "text-amber-800" : "text-stone-900"}`}>
                  <a id={`sss-${i + 1}`} className="scroll-mt-20">{faq.q}</a>
                </h4>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                  openIndex === i ? "bg-amber-500 text-white rotate-180" : "bg-stone-100 text-stone-500"
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-stone-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Link to="/istanbul-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-building-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">İstanbul SSS</p>
            <p className="text-xs text-stone-400">Boğaz ve tarihi yarımada rehberi</p>
          </Link>
          <Link to="/kapadokya-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-landscape-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Kapadokya SSS</p>
            <p className="text-xs text-stone-400">Peri bacaları ve balon turları</p>
          </Link>
          <Link to="/trabzon-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-water-flash-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Trabzon SSS</p>
            <p className="text-xs text-stone-400">Karadeniz ve yayla rehberi</p>
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MardinFaq;
